module.exports = __webpack_public_path__ + "img/centlogo.137dd3f7.png";